<template>
  <div>
    <tag-label-group v-if="homeworkHelpTypeItems.length" :items="homeworkHelpTypeItems" title="Types of help" class="mt-16" />
    <tag-label-group v-if="homeworkHelpSubjectItems.length" :items="homeworkHelpSubjectItems" title="Subjects" class="mt-16" />
  </div>
</template>

<script lang="ts">
import TagLabelGroup from '@/components/tag_label_group/TagLabelGroup.vue';
import { homeworkHelpTypeMap, homeworkHelpSubjectMap, HomeworkHelpType } from '../../__types__/HomeworkHelpTypes';

interface TagItem {
  text: string;
}

export default {
  name: 'ProfileHomeworkHelp',
  components: { TagLabelGroup },
  props: {
    homeworkHelpType: {
      type: Array as () => HomeworkHelpType[],
      default: () => [],
    },
    homeworkHelpSubjects: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  computed: {
    homeworkHelpTypeItems(): TagItem[] {
      return this.homeworkHelpType
        .filter((type): type is HomeworkHelpType => type in homeworkHelpTypeMap)
        .map((type) => homeworkHelpTypeMap[type]);
    },
    homeworkHelpSubjectItems(): TagItem[] {
      return this.homeworkHelpSubjects.map((subject) => homeworkHelpSubjectMap[subject] || { text: subject });
    },
  },
};
</script>
